import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { Auth } from 'aws-amplify';
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';

import Button, { EButtonColors } from 'components/Base/Button';
import { Row, Col } from 'components/Base/Grid';
import Image from 'components/Base/Image';
import google from 'assets/google.svg';
import { Screens } from 'core/CssVariables';
import { NotifiableError } from '@bugsnag/js';
import { SDivider } from './ButtonGroup.style';
import { buttonGroupPropsMap } from './ButtonGroup.data';
import { EVia, EButtonText, TButtonGroupsProps } from './ButtonGroup.type';
import { bugsnagClient } from '../../../../../ErrorBoundary';

const LoginButtonGroups = ({ mode, via, onChangeVia }: TButtonGroupsProps) => {
  const [searchParams] = useSearchParams();
  const leasePacketCode = searchParams.get('leasePacketCode');
  const isSmall = useMediaQuery({
    query: `(max-height: ${Screens.ScreensLG})`,
  });
  const isMobile = useMediaQuery({
    query: `(max-width: ${Screens.ScreensMD})`,
  });
  const hideViaPhoneBtn = false;
  return (
    <Col>
      <SDivider className="mt-0 mb-2">or</SDivider>
      <Row gutter={[15, 16]} justify="space-between" align="middle">
        <Col span={isMobile || hideViaPhoneBtn ? 24 : 12}>
          <Button
            size={isSmall ? 'small' : 'middle'}
            color={EButtonColors.Info}
            className="w-100"
            onClick={() => {
              if (leasePacketCode) {
                localStorage.setItem('leasePacketCode', leasePacketCode);
              }
              Auth.federatedSignIn({
                provider: CognitoHostedUIIdentityProvider.Google,
              }).catch(err => bugsnagClient?.notify(err as NotifiableError));
            }}
          >
            <Image
              width={16}
              height={16}
              src={google}
              alt="google-log"
              className="mr-1"
            />
            Continue with Google
          </Button>
        </Col>
        {!hideViaPhoneBtn && (
          <Col span={isMobile ? 24 : 12}>
            <Button
              size="middle"
              className="w-100"
              onClick={() => onChangeVia(via)}
              {...buttonGroupPropsMap[EVia[via]]}
            >
              {EButtonText[`${via}_${mode}` as keyof typeof EButtonText]}
            </Button>
          </Col>
        )}
      </Row>
    </Col>
  );
};

export { EVia };

export default LoginButtonGroups;
